var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('equipment-schedule',{attrs:{"name-table":"client-contract-maintenance-equipment-schedule","settings":_vm.settings,"general":_vm.general,"maint-data":_vm.sorItem,"is-equipment-schedule":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }